
import { Box, Typography, IconButton, Avatar } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ImageIcon from '@mui/icons-material/Image';
import { Base64Image } from '../../../utils/settings';
import IconReusable from '../../../components/IconReusable';
import { useSelector } from 'react-redux';

const FilePreviewCard = ({ filePreview, uploadedFile=null , isExisting, onDelete=null }) => {
  const showHistory = useSelector(state => state.entityReducer.show_history);
  return (
    <Box
      sx={{
        py: 1.5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Box display="flex" alignItems="center">
        {(() => {
          const fileName = uploadedFile?.name || uploadedFile?.file_name || '';
          const isPdf = fileName.toLowerCase().endsWith('.pdf');
          const isImage = fileName.toLowerCase().match(/\.(jpg|jpeg|png|gif|bmp|webp)$/);
          
          if (isPdf) {
            return (
              <Avatar
                sx={{ width: 56, height: 56, marginRight: '15px', borderRadius: '5px', bgcolor: 'error.main' }}
              >
                <PictureAsPdfIcon sx={{ color: 'white' }} />
              </Avatar>
            );
          }
          
          if (isImage && filePreview) {
            if (filePreview.startsWith('data:image') || filePreview.startsWith('blob:') || filePreview.startsWith('http')) {
              return (
                <Avatar
                  src={filePreview}
                  sx={{ width: 56, height: 56, marginRight: '15px', borderRadius: '5px' }}
                />
              );
            } else if (!filePreview.startsWith('data:image')) {
              return (
                <Base64Image
                  base64String={filePreview}
                  style={{ width: 56, height: 56, marginRight: '15px', borderRadius: '5px' }}
                  alt="preview"
                />
              );
            }
          }
          
          if (filePreview && isExisting) {
            if (filePreview.startsWith('data:image') || filePreview.startsWith('blob:') || filePreview.startsWith('http')) {
              return (
                <Avatar
                  src={filePreview}
                  sx={{ width: 56, height: 56, marginRight: '15px', borderRadius: '5px' }}
                />
              );
            } else {
              return (
                <Base64Image
                  base64String={filePreview}
                  style={{ width: 56, height: 56, marginRight: '15px', borderRadius: '5px' }}
                  alt="preview"
                />
              );
            }
          }
          
          if (isImage) {
            return (
              <Avatar
                sx={{ width: 56, height: 56, marginRight: '15px', borderRadius: '5px', bgcolor: 'primary.main' }}
              >
                <ImageIcon sx={{ color: 'white' }} />
              </Avatar>
            );
          }
          return (
            <Avatar
              sx={{ width: 56, height: 56, marginRight: '15px', borderRadius: '5px', bgcolor: 'grey.400' }}
            >
              <ImageIcon sx={{ color: 'white' }} />
            </Avatar>
          );
        })()}
        <Box>
          <Typography variant="body2" 
            sx={{
              wordBreak: 'break-word',
              overflowWrap: 'anywhere',
              minWidth: '200px',
              display: 'block',
            }}
        >
            {uploadedFile?.name || uploadedFile?.file_name || 'Uploaded File'}
          </Typography>
        </Box>
      </Box>
      {onDelete && (
        <IconButton 
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onDelete();
          }} 
          sx={{ marginLeft: '10px' }}
        >
        <IconReusable name='Delete' color={ !showHistory ? '#995A00' : '#E5E5E5' } />
        </IconButton>
      )}
      {/* {!onDelete && (
        <div style={{ padding: '8px', color: '#999', fontSize: '12px' }}>
          No delete handler
        </div>
      )} */}
    </Box>
  );
};

export default FilePreviewCard;
